import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function phoneNumberValidator(): ValidatorFn {
  const phoneRegex = /^\+\d{1,3}\d{8,12}$/;


  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }

    const isValid = phoneRegex.test(value);
    return isValid ? null : { pattern: true };
  };
}
